import { Component, OnInit,ViewChild} from '@angular/core';
import {ProjectService} from '../../../services/project.service/project.service'
import { Router } from '@angular/router';
import { ProjectDetail } from '../../../services/project.service/ProjectCover';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import { ProjectDetails } from '../../../services/project.service/projectdetail.service';
import { publicationsService } from 'src/app/services/publication.service/publication.service';
import { Publication } from 'src/app/services/publication.service/publication';
import { GroupByPipe, OrderByPipe } from 'ngx-pipes';
import { AnalyticsService } from 'src/app/services/analytics.service/analytics.service';
@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.less'],
  providers:[GroupByPipe,OrderByPipe]
})
export class ProjectDetailsComponent implements OnInit{

  router:Router;
  currentProject:ProjectDetail;
  
  currentProject_pubs:Publication[]
  
  projectService:ProjectService;
  pubService:publicationsService;
  analyticsService:AnalyticsService;
  pub_group={}
  constructor(router:Router, projectService:ProjectService, pubService:publicationsService, analyticsService:AnalyticsService, public groupbyPipe:GroupByPipe) { 
    this.router = router;
    this.projectService  = projectService;
    this.pubService = pubService;
    this.analyticsService = analyticsService;
  }
  
  ngOnInit(): void {
    
    this.currentProject = this.projectService.getSelectedProject();
    if(!this.currentProject){
      this.goBack
    }
    this.analyticsService.eventEmitter("read_proj_details","projects","load",this.currentProject.id)
    
    
  }

  goBack(){
    this.router.navigateByUrl('project');
  }

//   togglePaused() {
//     if (this.paused) {
//       this.carousel.cycle();
//     } else {
//       this.carousel.pause();
//     }
//     this.paused = !this.paused;
//   }

//   onSlide(slideEvent: NgbSlideEvent) {
//     if (this.unpauseOnArrow && slideEvent.paused &&
//       (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
//       this.togglePaused();
//     }
//     if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
//       this.togglePaused();
//     }

// }

getPubsbyProjectId(){
  let publications =  this.pubService.getPublicationsByProjectId(this.currentProject.id);
  this.pub_group = this.groupbyPipe.transform(publications,'year');
    const arrayReverseObj = 
  obj => Object.keys(obj).sort().reverse().map(key=> ({year:key,pubs:obj[key]}) );

  this.pub_group = arrayReverseObj(this.pub_group)

  return this.pub_group
}

}
